/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileDownloadModel } from '../../models/file-download-model';
import { MonthlyUsageReportRequest } from '../../models/monthly-usage-report-request';

export interface AdminGetMonthlyUsagePost$Params {
  
    /**
     * Date range and optional multi-select filters
     */
    body?: MonthlyUsageReportRequest
}

export function adminGetMonthlyUsagePost(http: HttpClient, rootUrl: string, params?: AdminGetMonthlyUsagePost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<FileDownloadModel>> {
  const rb = new RequestBuilder(rootUrl, adminGetMonthlyUsagePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<FileDownloadModel>;
    })
  );
}

adminGetMonthlyUsagePost.PATH = '/Admin/GetMonthlyUsage';
